import { url } from '../config';

/** SEO-2 Batch 2: title and meta description length limits for SERP. */
export const SEO_TITLE_MAX_LENGTH = 60;
export const SEO_META_DESCRIPTION_MAX_LENGTH = 160;

export function truncateForTitle(text, maxLength = SEO_TITLE_MAX_LENGTH) {
  if (text == null || text === '') {
    return '';
  }
  const trimmed = String(text).trim();
  if (trimmed.length <= maxLength) {
    return trimmed;
  }
  return `${trimmed.slice(0, maxLength - 1).trim()}…`;
}

export function truncateForMetaDescription(
  text,
  maxLength = SEO_META_DESCRIPTION_MAX_LENGTH,
) {
  if (text == null || text === '') {
    return '';
  }
  const normalized = String(text).replace(/\s+/g, ' ').trim();
  if (normalized.length <= maxLength) {
    return normalized;
  }
  return `${normalized.slice(0, maxLength - 1).trim()}…`;
}

export function buildAbsoluteCanonical(pathname) {
  const base = String(url).replace(/\/$/, '');
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${path}`;
}
